// Schalter fuer die globalen Journey-Fixes. Wert kommt vom Backend (Live standardmaessig AUS).
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let pending = null;

export function loadJourneyFlags() {
  if (!pending) {
    pending = api.get("/features/journey-flags")
      .then((r) => { cached = r.data?.journey_fixes === true; return cached; })
      .catch(() => { cached = false; return false; });
  }
  return pending;
}

export const journeyFixesOn = () => cached === true;

export function useJourneyFixes() {
  const [on, setOn] = useState(cached);
  useEffect(() => { loadJourneyFlags().then(setOn); }, []);
  return on;
}

// Bis der Schalter geladen ist: nichts anzeigen (kein Flackern Dashboard -> Cockpit).
export function CockpitWord() {
  const on = useJourneyFixes();
  if (on === null) return null;
  return "Mitgliederbereich";
}

